import { DirectIndexType, PricingPageAnchor } from "@frec-js/common-client";
import { FC } from "react";

import { IndicesTable } from "../../components/IndicesTable";

type PricingIndicesProps = {
  availableIndexTypes?: DirectIndexType[];
  id?: string;
};

export const PricingIndices: FC<PricingIndicesProps> = ({
  availableIndexTypes,
  id = PricingPageAnchor.ExploreIndices,
}) => {
  return (
    <section
      id={id}
      className="grid grid-cols-[auto_minmax(0,86rem)_auto] grid-rows-[96px_auto_auto_96px_1px] bg-[#F4F2EE]"
    >
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v flex flex-col items-center gap-3 px-6 lg:mx-12 lg:border-x lg:px-16">
        <h2 className="text-center">Choose from multiple indices</h2>
        <p className="lg:text-20 max-w-[600px] px-6 pt-6 pb-12 text-center">
          With multiple indices to choose from, you can direct index for as
          little as a 0.10% annual AUM fee.
        </p>
      </div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">
        <IndicesTable availableIndexTypes={availableIndexTypes} />
      </div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="dotted-h col-span-3 border-b">{/* empty */}</div>
    </section>
  );
};
